import { sendTrack } from "../utilities/track";

document.addEventListener("DOMContentLoaded", pennyInit);

function pennyInit() {
  window.addEventListener("message", (event) => {
    const data = event.data || {};

    if (data.type !== "analytics-event") return;
    if (!data.chat_state) return;

    sendTrack(data.chat_state, {
      agent: "Penny",
      // eslint-disable-next-line camelcase
      agent_version: data.agent_version || 58,
      placement: "website",
    });
  });
}
